import { DocResponse, DocumentRequest } from '../types/api';

import { lifeApi } from './base';

const postDocument = lifeApi.injectEndpoints({
  endpoints: (builder) => ({
    postDocument: builder.mutation<DocResponse, DocumentRequest>({
      query: (body) => ({
        url: '/documents',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { usePostDocumentMutation } = postDocument;
